export default __webpack_public_path__ + "static/ss4JsbF-0f80b179280041a1d89d4bb96fecfe67.jpeg";